<template>
  <div>
    <el-form>
      <el-select v-model="activityStatus" @change="showSelected" clearable placeholder="请选择审核状态">
        <el-option
          v-for="item in statusOptions"
          :key="item.key"
          :label="item.value"
          :value="item.key">
        </el-option>
      </el-select>
      <el-input placeholder="请输入ID" v-model="activityId" style="width: 250px;margin-left: 1%"></el-input>
      <el-button type="primary" style="margin-left: 1%" @click="findById">查询</el-button>
      <el-input placeholder="请输入标题" v-model="productionName" style="width: 250px;margin-left: 1%"></el-input>
      <el-button type="primary" style="margin-left: 1%" @click="fuzzySearch">查询</el-button>
    </el-form>
    <el-table
      :data="activityData"
    >
      <el-table-column align="center" label="id" prop="id"></el-table-column>
      <el-table-column align="center" label="标题" prop="productionName"></el-table-column>
      <el-table-column align="center" label="活动图片">
        <template slot-scope="scope">
          <el-image :src="scope.row.productionPicture" @click="amplification(scope.row.productionPicture)"></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="作者" prop="userName"></el-table-column>
      <el-table-column align="center" label="手机号" prop="phone"></el-table-column>
      <el-table-column align="center" label="阵营" prop="camp">
        <template slot-scope="scope1">
          <span v-if="scope1.row.camp==1">经管学院</span>
          <span v-else>汇华学院</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="审核状态">
        <template slot-scope="scope2">
          <el-button v-if="scope2.row.auditState=='PASSED'" type="text">通过</el-button>
          <el-button v-else-if="scope2.row.auditState=='WAITING'" type="text" style="color: #e6a23c">待审核</el-button>
          <el-button v-else type="text" style="color: #f56c6c">拒绝</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="是否删除">
        <template slot-scope="scope3">
          <span v-if="scope3.row.delete">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" prop="createTime"></el-table-column>
      <el-table-column align="center" label="操作" width="300px">
        <template slot-scope="scope4">
          <el-button type="primary" @click="auditProduction(scope4.row,true)">通过</el-button>
          <el-button type="danger" @click="auditProduction(scope4.row,false)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalAcount">
    </el-pagination>
    <el-dialog :visible.sync="showPicDetail" width="600px">
      <el-image :src="imgDetails"/>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "activitys",
    data() {
      return {
        activityData: null,
        currentPage: 0,
        pageSize: 10,
        totalAcount: 0,
        activityStatus: '',
        statusOptions: [{key: 'WAITING', value: '待审核'}, {key: 'PASSED', value: '通过'}, {key: 'REJECTED', value: '拒绝'}],
        activityId: '',
        productionName: '',
        imgDetails: '',
        showPicDetail: false,
      }
    },
    methods: {
      getActivityLists(status) {
        console.log(2);
        console.log(this.currentPage);
        let that = this
        this.$http.post(this, '/activity/activityLists',
          {
            currentPage: this.currentPage == 0 ? this.currentPage : this.currentPage - 1,
            pageSize: this.pageSize,
            auditState: status == null ? null : status
          }).then(res => {
          console.log(res);
          that.activityData = res.data.data
          that.totalAcount = res.data.count
          that.currentPage = res.data.page + 1
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getActivityLists()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val
        this.getActivityLists()
      },
      showSelected() {
        console.log(this.activityStatus);
        // 状态切换时，查询选中状态对应的数据
        this.getActivityLists(this.activityStatus)

      },
      auditProduction(row, status) {
        console.log(1);
        console.log(this.currentPage);
        let that = this
        let auditStatus = status == true ? 'PASSED' : 'REJECTED'
        this.$http.post(this, '/activity/auditActivity', {id: row.id, auditState: auditStatus}).then(res => {
          console.log(res);
          if (res.code == 200) {
            that.getActivityLists()
            that.$message({
              message: '审核成功!',
              type: "success"
            })
          } else {
            that.$message({
              message: '审核失败！',
              type: "error"
            })
          }
        })
      },
      findById() {
        let that = this
        if (null == this.activityId || this.activityId == '') return;
        this.$http.post(this, '/activity/findById', {activityId: this.activityId}).then(res => {
          if (res && res.code == 200) {
            that.activityData = res.data
          }
        })
      },
      fuzzySearch() {
        console.log(this.productionName);
        let that = this
        this.$http.post(this, '/activity/fuzzySearch', {
          currentPage: this.currentPage == 0 ? this.currentPage : this.currentPage - 1,
          pageSize: this.pageSize, productionName: this.productionName
        }).then(res => {
          that.activityData = res.data.data
          that.currentPage = res.data.page + 1
          that.totalAcount = res.data.count
        })
      },
      amplification(imgUrl){
        this.imgDetails = imgUrl
        this.showPicDetail = true
      }
    },
    created() {
      this.getActivityLists()
    }
  }
</script>

<style scoped>

</style>
